export const endPoints = {
    STOP_ARRIVALS: '/stop/arrivals',
    VEHICLE_STOP_ARRIVALS: '/stop/arrivals/temp',
    STOPS: '/stop',
    ROUTES_LISTING: '/autocomplete/route',
    ROUTE_DETAIL: '/routedetails',
    ROUTE_RECENT_TRIP: '/routeStat/recentTrips',
    ROUTE_RECENT_TRIP_COUNT: '/routeStat/recentTripsCount',
    VEHICLE_LISTING:'/vehicle/autocomplete',
    VEHICLE_DETAIL:'/vehicle/detail',
    VEHICLE_RECENT_TRIP:'/vehicleStat/recentTrips',
    VEHICLE_RECENT_TRIP_COUNT:'/vehicleStat/recentTripsCount',
    TRIP_SESSION:'getSession',
    ALERTS:'/alert',
    ALERTS_DETAIL:'/getAlertDetails'
};

export const GPSEndpoint = {
    ENTERPRISE: 'enterprise/',
    CONSOLIDATED: 'consolidated/',
    GPS_VEHICLE_DISTANCE: 'enterprise/distance/vehicle/'
};

